// Actions
// export const API_CURRENT_OVERVIEW_PMS_RESPONSE_SUCCESS = "API_CURRENT_OVERVIEW_PMS_RESPONSE_SUCCESS";
// export const API_CURRENT_OVERVIEW_PMS_RESPONSE_ERROR = "API_CURRENT_OVERVIEW_PMS_RESPONSE_ERROR";
// export const GET_CURRENT_OVERVIEW_PMS = "GET_CURRENT_OVERVIEW_PMS";

export const API_SA_RESPONSE_SUCCESS = "API_SA_RESPONSE_SUCCESS";
export const API_SA_ERROR = "API_SA_ERROR";
export const GET_SA = "GET_SA";
